"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const renderer_1 = require("../renderer");
var Cesium = window['Cesium'];
class BlankAnnotationRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
    }
    onAdd(p, args) {
        // console.log('##annot');
        var caption = {
            showBackground: true,
            fourd_ref: p.id,
            font: '14px monospace',
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        };
        caption = this.cesium.annotationLabels.add(caption);
        var ref = {
            object: caption,
            plottable: p
        };
        return rxjs_1.of(ref);
    }
    onUpdate(p, pr, args) {
        pr.object.position = p.catresian();
        pr.object.name = p.name;
        pr.object.text = p.name;
        if (args) {
            Object.keys(args).forEach(k => pr.object[k] = args[k]);
        }
        return rxjs_1.of(pr);
    }
    onRemove(obj, pr) {
        if (pr.object.label)
            this.cesium.annotationLabels.remove(pr.object.label);
        return rxjs_1.of(null);
    }
}
exports.BlankAnnotationRenderer = BlankAnnotationRenderer;
class LegacyAnnotationRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
    }
    onAdd(p, args) {
        var pin = {
            position: p.catresian(),
            name: p.name,
            text: p.name,
            fourd_ref: p.id,
            font: '14px monospace',
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.TOP,
            disableDepthTestDistance: 20,
            billboard: {
                heightReference: p.lheight ? Cesium.HeightReference.NONE : Cesium.HeightReference.CLAMP_TO_GROUND,
                image: null,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance: Number.POSITIVE_INFINITY
            }
        };
        var caption = {
            position: p.catresian(),
            name: p.name,
            text: p.name,
            showBackground: true,
            fourd_ref: p.id,
            font: '14px monospace',
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.TOP,
            disableDepthTestDistance: 20
        };
        if (!p.style || !p.style.hidePin)
            pin = this.cesium.annotationDataSource.entities.add(pin);
        if (p.style && p.style.caption)
            caption = this.cesium.annotationLabels.add(caption);
        var ref = {
            object: {
                pin: !p.style || !p.style.hidePin ? pin : null,
                label: p.style && p.style.caption ? caption : null
            },
            plottable: p
        };
        // if theres a byo style function
        if (args && args.styleFunction)
            args.styleFunction(ref);
        // console.log('##pin',pin);
        return rxjs_1.of(ref);
    }
    onRemove(obj, pr) {
        if (pr.object.pin)
            this.cesium.annotationDataSource.entities.remove(pr.object.pin);
        if (pr.object.label)
            this.cesium.annotationLabels.remove(pr.object.label);
        return rxjs_1.of(null);
    }
}
exports.LegacyAnnotationRenderer = LegacyAnnotationRenderer;
